import { useMemo, useState } from "react";
import { useFraudAlertsController } from "shared/queries/useFraudAlertsController";
import type { FraudAlert } from "api/propertyShield";

const PER_PAGE = 20;
const OPEN_STATUSES = new Set<FraudAlert["status"]>([
  "pending_confirmation",
  "active"
]);

// Newest first from the API; open alerts are lifted to the top of the page.
const openFirst = (alerts: FraudAlert[]) => [
  ...alerts.filter((alert) => OPEN_STATUSES.has(alert.status)),
  ...alerts.filter((alert) => !OPEN_STATUSES.has(alert.status))
];

export const useUnitFraudAlerts = (unitId?: number) => {
  const [page, setPage] = useState(1);
  const enabled = Boolean(unitId);

  const { alerts, pageCount, isLoading } = useFraudAlertsController(
    { unit_id: unitId, page, per_page: PER_PAGE },
    { enabled }
  );
  const { total: needsReviewCount } = useFraudAlertsController(
    { unit_id: unitId, status: "pending_confirmation", per_page: 1 },
    { enabled }
  );

  const sortedAlerts = useMemo(() => openFirst(alerts), [alerts]);

  return {
    alerts: sortedAlerts,
    needsReviewCount,
    pageCount,
    page,
    setPage,
    isLoading
  };
};
